import React from 'react';

const CameraIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg
      className={className}
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props} // ← allows all SVG features
    >
      <g filter="url(#filter0_d_5380_15558)">
        <circle cx="26" cy="26" r="15.75" fill="#FAFAFA" stroke="#CFCFCF" strokeWidth="0.5" />
        <path
          d="M23.4269 20.2841L23.2483 20.5162L22.5698 21.4269H18.5698V31.7126H33.4269V21.4269H29.4269L28.7483 20.5162L28.5698 20.2841H23.4269ZM23.9983 21.4269H27.9983L28.6769 22.3376L28.8555 22.5698H32.284V30.5698H19.7126V22.5698H23.1412L23.3198 22.3376L23.9983 21.4269ZM21.4269 23.1412C21.1122 23.1412 20.8555 23.3979 20.8555 23.7126C20.8555 24.0274 21.1122 24.2841 21.4269 24.2841C21.7416 24.2841 21.9983 24.0274 21.9983 23.7126C21.9983 23.3979 21.7416 23.1412 21.4269 23.1412ZM25.9983 23.1412C24.1122 23.1412 22.5698 24.6836 22.5698 26.5698C22.5698 28.4559 24.1122 29.9983 25.9983 29.9983C27.8845 29.9983 29.4269 28.4559 29.4269 26.5698C29.4269 24.6836 27.8845 23.1412 25.9983 23.1412ZM25.9983 24.2841C27.2684 24.2841 28.284 25.2997 28.284 26.5698C28.284 27.8399 27.2684 28.8555 25.9983 28.8555C24.7282 28.8555 23.7126 27.8399 23.7126 26.5698C23.7126 25.2997 24.7282 24.2841 25.9983 24.2841Z"
          fill="#1C1F22"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5380_15558"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.433243 0 0 0 0 0.957292 0 0 0 0 0.676238 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5380_15558" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5380_15558" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default CameraIcon;
